import React, { useContext, useEffect } from 'react';

import AppContext from '../context';

const Results = () => {
  const context = useContext(AppContext);

  useEffect(() => {
    context.getResults();

    return () => {
      context.clearResults();
    }
  }, []);

  return (
    <div className="program-filter program-results">
      <h3>Results</h3>

      {context.results.length ?
        <div className="has-results">
          {context.results.map((result, index) =>
            <a
              className="program-result"
              key={index}
              href={`/pages/${result.slug}`}
            >
              <div className="program-result__image">
                {result.hero ?
                  <img className="top-image" src={result.hero}/>
                : null}

                {result.thumb ?
                  <img className="left-image" src={result.thumb}/>
                : null}
              </div>

              <div className="program-result__details">
                <h2>{ result.title }</h2>
                <span className="program-result__grade">
                  { result.grades }
                </span>
                <div dangerouslySetInnerHTML={{__html: result.excerpt}}></div>
              </div>
            </a>
          )}
        </div>
      : context.displayText ?
        <p className="no-results">
          {context.displayText.no_results_text ?
            <span>{ context.displayText.no_results_text }</span>
          :
            <span>Your search returned no results.</span>
          }
        </p>
      : null}
    </div>
  );
}

export default Results;